import React from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import GridList from '@material-ui/core/GridList'
import GridListTile from '@material-ui/core/GridListTile'
import GridListTileBar from '@material-ui/core/GridListTileBar'
import Slider from 'react-slick'
import LeftArrow from 'react-icons/lib/md/chevron-left'
import RightArrow from 'react-icons/lib/md/chevron-right'
import Dot from 'react-icons/lib/io/ios-circle-filled'
import cx from 'classnames'

const styles = (theme) => ({
  root: {
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      marginBottom: 25,
    },
  },
  thumbnailWrapper: {
    '&:hover': {
      '& img': {
        transform: 'scale(0.88) rotate(2deg)',
      },
    },
  },
  thumbnail: {
    borderRadius: '50%',
    maxWidth: 140,
    transition: 'transform 0.4s',
    [theme.breakpoints.down('xs')]: {
      maxWidth: 70,
    },
  },
  profileCaption: {
    color: `${theme.palette.primary.light} !important`,
    '&:hover': {
      color: '#36edff !important',
      opacity: 1,
    },
  },
  arrow: {
    color: theme.palette.primary.main,
    transform: 'scale(2.2)',
    top: 55,
    [theme.breakpoints.down('xs')]: {
      top: 40,
      transform: 'scale(1.4)',
    },
    '&:hover': {
      color: theme.palette.link.hovering,
    },
  },
  pagingDot: {
    position: 'relative',
    color: theme.palette.primary.main,
    '&:hover': {
      color: theme.palette.highlight.lightTeal,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.85em',
      top: 15,
    },
  },
})

const Instagram = (props) => {
  const { classes, items } = props

  const PrevArrow = (props) => {
    const { className, style, onClick } = props
    return (
      <LeftArrow
        onClick={onClick}
        className={cx(className, classes.arrow)}
        style={style}
      />
    )
  }

  const NextArrow = (props) => {
    const { className, style, onClick } = props
    return (
      <RightArrow
        onClick={onClick}
        className={cx(className, classes.arrow)}
        style={style}
      />
    )
  }

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 1500,
    slidesToShow: 5,
    slidesToScroll: 3,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    customPaging: () => <Dot className={classes.pagingDot} />,
    responsive: [
      {
        breakpoint: 290,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 315,
        settings: {
          centerMode: true,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 390,
        settings: {
          centerMode: true,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          centerMode: true,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          initialSlide: 2,
        },
      },
    ],
  }

  return (
    <div className={classes.root}>
      {items.length && (
        <Slider {...settings}>
          {items.map(({ node }, i) => {
            return (
              <div className={classes.thumbnailWrapper} key={`sliderItem${i}`}>
                <a href={node.url} target="_blank">
                  <img
                    className={classes.thumbnail}
                    src={node.thumbnail}
                    style={{ objectFit: 'cover' }}
                  />
                </a>
              </div>
            )
          })}
        </Slider>
      )}
    </div>
  )
}

Instagram.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      node: PropTypes.shape({
        thumbnail: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        user: PropTypes.string,
        date: PropTypes.string.isRequired,
      }),
    }),
  ),
}

export default withStyles(styles)(Instagram)



// WEBPACK FOOTER //
// ./src/components/Frontpage/Instagram.js